// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"0297338a","698":"107a2a18"}[chunkId] + ".chunk.css";
};